import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { PlusIcon } from "@heroicons/react/16/solid";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import { Input } from "../../../design/input";

interface Props {}

const CreateKeyButton: React.FC<Props> = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [keyName, setKeyName] = useState("");

  const handleSubmit = async () => {
    await addDoc(collection(db, "keys"), {
      name: keyName,
      createdAt: Timestamp.now(),
    });
    setIsOpen(false);
  };

  const clearForm = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button type="button" onClick={() => setIsOpen(true)}>
        <PlusIcon className="w-5 h-5" aria-hidden="true" /> Create Key
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Create Key</DialogTitle>
        <DialogBody>
          <Input
            type="text"
            placeholder="Key Name"
            value={keyName}
            onChange={(e) => setKeyName(e.target.value)}
          />
        </DialogBody>
        <DialogActions>
          <Button plain onClick={clearForm}>
            Cancel
          </Button>
          <Button disabled={isSaving} onClick={handleSubmit}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateKeyButton;
